<template lang="html">
  <section class="ctn-articles take-place column start">
		<div class="ctn-actualities column">
			<div class="ctn-filters row">
				<div class="filter" v-for="(tag, key) in tags" :class="{active: isTagActive(key)}" @click="activeTag(key)" v-bind:key="key">
					{{ tag.name }}
				</div>
			</div>
			<div class="ctn-columns row">
				<div class="ctn-columns row">
					<div class="column-article">
						<custom-article-small :article="article" v-for="(article, key) in colsAllActualities[0]" v-bind:key="key"/>
					</div>
					<div class="column-article">
						<custom-article-small :article="article" v-for="(article, key) in colsAllActualities[1]" v-bind:key="key"/>
					</div>
				</div>
			</div>
		</div>
  </section>
</template>

<script>
import CustomArticleSmall from '@/common/components/article-small'
import { mapGetters } from 'vuex'
export default {
	name: 'AllActualities',
	components: {
		CustomArticleSmall
	},
	data () {
		return {
			activeTags: []
		}
	},
	mounted () {
		this.fillColumn(this.news, this.colsAllActualities)
	},
	methods: {
		isTagActive (key) {
			return (this.activeTags.indexOf(key) !== -1)
		},
		activeTag (key) {
			if (this.activeTags.indexOf(key) === -1) {
				this.activeTags.push(key)
			} else {
				this.activeTags.splice(this.activeTags.indexOf(key), 1)
			}
		},
		filter (news) {
			if (this.activeTags.length === 0) {
				return news
			} else {
				let result = []

				news.forEach((n) => {
					let shouldBeAdd = false
					n.news_tags.forEach((t) => {
						let isTag = false
						this.activeTags.forEach((tag) => {
							if (typeof t === 'number') {
								if (t === this.tags[tag].wordpress_tag_id) isTag = true
							} else {
								if (t.tags.wordpress_tag_id === this.tags[tag].wordpress_tag_id) isTag = true
							}
						})

						if (isTag) shouldBeAdd = true
					})

					if (shouldBeAdd) result.push(n)
				})

				return result
			}
		},
		fillColumn (start, end) {

		}
	},
	computed: {
		...mapGetters({
			news: 'allNews',
			tags: 'tags'
		}),
		colsAllActualities () {
			let news = this.filter(this.news)
			let result = [[], []]
			news.forEach(article => {
				let sizeA = 0
				let sizeB = 0
				result[0].forEach(item => {
					sizeA += (item.size === 'big') ? 1 : 0.5
				})
				result[1].forEach(item => {
					sizeB += (item.size === 'big') ? 1 : 0.5
				})
				const foo = (sizeA <= sizeB) ? result[0] : result[1]
				foo.push(article)
			})

			return result
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/views/Actualities/Actualities.vue